module.exports = __webpack_public_path__ + "assets/img/hill-1.59cc08db.png";